<template>
  <div>
    <h1>Manage Application Settings</h1>

    <div>
      <b-card no-body>
        <b-tabs pills card vertical nav-wrapper-class="w-25">
          <b-tab title="Email Settings" active v-if="isAdmin()">
            <b-card-text><EmailSetting/></b-card-text>
          </b-tab>
          <b-tab title="Welcome Page" v-if="isAdmin()">
            <b-card-text><WelcomeSetting/></b-card-text>
          </b-tab>
          <b-tab title="Welcome and Onboarding Settings" v-if="isCwd()">
            <b-card-text><QuickStartSetting/></b-card-text>
          </b-tab>
          <b-tab title="Hiring Status Goal Settings" v-if="isAdmin()">
            <b-card-text><HiringStageGoal/></b-card-text>
          </b-tab>

        </b-tabs>

      </b-card>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import axiosRetry from 'axios-retry'
  import { validationMixin } from 'vuelidate'
  import { required, minLength } from 'vuelidate/lib/validators'
  import { statusOptions } from '@/mixins/statusOptions.js'
  import WelcomeSetting from '@/components/WelcomeSetting'
  import EmailSetting from '@/components/EmailSetting'
  import QuickStartSetting from '@/components/QuickStartSetting'
  import HiringStageGoal from "@/components/HiringStageGoal";
  import {roleService} from "@/mixins/roleService";


  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    mixins: [
      validationMixin,
      statusOptions,
      roleService
    ],
    components: {
      HiringStageGoal,
      WelcomeSetting,
      EmailSetting,
      QuickStartSetting,
    },
    data: () => ({
      selectedStatus: '',
      newItem: '',
      checklist: {},
    }),

     validations: {
        selectedStatus: { required  },
     },

    watch: {
      selectedStatus() {
        console.log("selected status changed")
        this.loadChecklist()
      }
    },

    created () {
      this.initialize()
    },

    methods: {

      initialize () {
        
      },

      loadChecklist() {
         axios.get(`${process.env.VUE_APP_API_BASE_URL}/checklist/config/${this.selectedStatus}`)
            .then(response => {
                this.checklist = response.data;
            })
      },

      addToList() {
        var item = {
          id: -1,
          text: this.newItem,
          seqeuence: 9999
        }
        this.checklist.items.push(item)
        this.newItem = null
      },

      saveCheckList() {
        axios.post(`${process.env.VUE_APP_API_BASE_URL}/checklist/config`,
          this.checklist)
            .then(response => {
                this.checklist = response.data;
            })
      },

      removeList(item) {
        axios.delete(`${process.env.VUE_APP_API_BASE_URL}/checklist/config/${item.id}`)
            .then(response => {
              const index = this.checklist.items.indexOf(item);
              this.checklist.items.splice(index, 1);
            })
      }



    }
  }
</script>